import { Reducer } from '@reduxjs/toolkit';

const openEditorReducer: Reducer = (
  state, { payload },
) => (
  {
    ...state,
    openEditor: payload,
  }
);

export default openEditorReducer;
